//
// Module for common Tax Summary Step in Benefit Setup wizards
//
rs.module("participant/benefit/setup/common/wizard/taxsummarystep",

    ["common/visibility"],

    function (visibility) {

        // Initialize the module
        function initialize(jsSelectors) {

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var useRetirementDirectDepositCheckBox = stepContainer.js(jsSelectors.useRetirementDirectDepositCheckBox, { required: false });
            var directDepositContainer = stepContainer.js(jsSelectors.directDepositContainer, { required: false });

            // hide/show directDepositContainer on useRetirementDirectDepositCheckBox change
            useRetirementDirectDepositCheckBox.change(function () {
                visibility.setVisible(directDepositContainer, this.checked);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);